export type AppLanguage = 'en' | 'zh' | 'es' | 'fr' | 'de' | 'pt' | 'ja';

export const SUPPORTED_LANGUAGES: readonly AppLanguage[] = [
  'en',
  'zh',
  'es',
  'fr',
  'de',
  'pt',
  'ja',
];

const normalizeTag = (tag: string | null | undefined): AppLanguage | null => {
  if (!tag) return null;
  const base = tag.trim().toLowerCase().split('-')[0];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base)
    ? (base as AppLanguage)
    : null;
};

/** Pick the first supported language from the browser's preference list. */
export function detectLanguage(
  languages?: readonly (string | null | undefined)[]
): AppLanguage {
  const candidates = languages?.length
    ? languages
    : typeof navigator === 'undefined'
      ? []
      : [...(navigator.languages ?? []), navigator.language];

  for (const tag of candidates) {
    const language = normalizeTag(tag);
    if (language) return language;
  }

  return 'en';
}
